import { parseFragment } from "parse5";
import { isNotNull } from "./utils";
const isChildNodeComment = (childNode) => {
    return childNode.nodeName === "#comment";
};
const isChildNodeTextNode = (childNode) => {
    return childNode.nodeName === "#text";
};
const isChildNodeTemplate = (childNode) => {
    return childNode.nodeName === "template";
};
const isChildNodeDocumentType = (childNode) => {
    return childNode.nodeName === "#documentType";
};
const mapChildNodeToHtmlNode = (childNode) => {
    if (isChildNodeComment(childNode) ||
        isChildNodeDocumentType(childNode) ||
        isChildNodeTemplate(childNode)) {
        return null;
    }
    if (isChildNodeTextNode(childNode)) {
        return {
            type: "text",
            value: childNode.value,
        };
    }
    return {
        type: "element",
        tagName: childNode.tagName,
        children: childNode.childNodes
            .map((c) => mapChildNodeToHtmlNode(c))
            .filter(isNotNull),
        attrs: Object.fromEntries(childNode.attrs.map((attr) => [attr.name, attr.value])),
    };
};
export const parseHtml = (htmlString) => {
    const parsedHtml = parseFragment(htmlString);
    return parsedHtml.childNodes
        .map((node) => mapChildNodeToHtmlNode(node))
        .filter(isNotNull);
};
//# sourceMappingURL=parseHtml.js.map